// 短信路由配置
// import layoutHeaderAside from '@/layout/ghost-container'
import layoutHeaderAside from '@/layout/header-aside'

const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

export default [
  {
    path: '/message',
    name: 'Message',
    meta: {
      title: '短信',
      auth: true,
    },
    component: layoutHeaderAside,
    // redirect: { path: '/message/overview' },
    children: [
      {
        path: 'video/overview',
        name: 'videoOverview',
        meta: {
          title: '视频概览',
          auth: true,
        },
        component: _import('video/overview'),
      },
      {
        path: 'video/records',
        name: 'videoRecords',
        meta: {
          title: '上传记录',
          auth: true,
        },
        component: _import('video/records'),
      },

      {
        path: 'video/overview',
        name: 'videoOverview',
        meta: {
          title: '视频概览',
          auth: true,
        },
        component: _import('video/overview'),
      },

      {
        path: 'management/overview',
        name: 'ImagemOverview',
        meta: {
          title: '图片概览',
          auth: true,
        },
        component: _import('management/overview'),
      },
      {
        path: 'management/upload',
        name: 'Imagempload',
        meta: {
          title: '上传记录',
          auth: true,
        },
        component: _import('management/upload'),
      },

      {
        path: 'management/overview',
        name: 'ImagemOverview',
        meta: {
          title: '图片概览',
          auth: true,
        },
        component: _import('management/overview'),
      },

      {
        path: 'order',
        name: 'Order',
        meta: {
          title: '商品订单',
          auth: true,
        },
        component: _import('message/order'),
      },
      {
        path: 'service',
        name: 'service',
        meta: {
          title: '商品服务',
          auth: true,
        },
        component: _import('message/service'),
      },
      {
        path: 'overview',
        name: 'Overview',
        meta: {
          title: '短信概览',
          auth: true,
        },
        component: _import('message/overview'),
      },
      {
        path: 'recharge',
        name: 'Recharge',
        meta: {
          title: '充值记录',
          auth: true,
        },
        component: _import('message/recharge'),
      },
      {
        path: 'send',
        name: 'Send',
        meta: {
          title: '发送记录',
          auth: true,
        },
        component: _import('message/send'),
      },
      {
        path: 'smsPackage',
        name: 'SmsPackage',
        meta: {
          title: '短信套餐',
          auth: true,
        },
        component: _import('message/smsPackage'),
      },
      {
        path: 'smsCustom',
        name: 'SmsCustom',
        meta: {
          title: '自定义短信',
          auth: true,
        },
        component: _import('message/smsCustom'),
      },
    ],
  },
]
